import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import styles from './BaseLearningDetails.module.scss';
import { classes } from '../../../../lib/utils/cssUtils';

interface SkeletonBaseLearningDetailsViewProps {
  isLoading?: boolean;
  children: React.ReactNode;
}

const SkeletonBaseLearningDetailsView: React.FC<SkeletonBaseLearningDetailsViewProps> = ({ isLoading, children }) => {
  if (!isLoading) {
    return children;
  }

  return (
    <div className={styles.skeletonContainer}>
      <div className={styles.rowBackgroundWrapper}>
        <div className={styles.rowGridContainer}>
          <div className={styles.rowGrid}>
            <div className={styles.leftColumn}>
              <Skeleton height={30} className={styles.skeleton} />
            </div>
            <div className={styles.rightColumn}>
              <Skeleton height={30} className={styles.skeleton} />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.rowBackgroundWrapper}>
        <div className={styles.rowGridContainer}>
          <div className={styles.rowGrid}>
            <div className={styles.leftColumn}>
              <Skeleton height={30} className={styles.skeleton} />
            </div>
            <div className={styles.rightColumn}>
              <Skeleton height={200} className={styles.skeleton} />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.rowBackgroundWrapper}>
        <div className={styles.rowGridContainer}>
          <div className={styles.rowGrid}>
            <div className={styles.leftColumn}>
              <Skeleton height={30} className={styles.skeleton} />
            </div>
            <div className={classes(styles.rightColumn, styles.detailsSkeleton)}>
              <Skeleton height={80} className={styles.skeleton} />
              <Skeleton height={80} className={styles.skeleton} />
              <Skeleton height={80} className={styles.skeleton} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonBaseLearningDetailsView;
